module.exports = __webpack_public_path__ + "img/371.8dfb5dbe.png";